import {
  MODEL_TYPE_1_ID,
  MODEL_TYPE_2_ID,
  MODEL_TYPE_3_ID,
} from '@hbrisk/sp3-risk-model-support/models/modelTypes/ids.js';
import calculateType1CopyModelPostPayload from './type1.js';
import calculateType2CopyModelPostPayload from './type2.js';
import calculateType3CopyModelPostPayload from './type3.js';

// Mirrors the API's create/schemas.js `byType` map: types 1 and 2 carry
// upload-related fields that the type 3 create schema rejects.
const byType = {
  [MODEL_TYPE_1_ID]: calculateType1CopyModelPostPayload,
  [MODEL_TYPE_2_ID]: calculateType2CopyModelPostPayload,
  [MODEL_TYPE_3_ID]: calculateType3CopyModelPostPayload,
};

const calculateCopyModelPostPayload = (baseModel, createdById, orgId, permissions) =>
  byType[baseModel.type](baseModel, createdById, orgId, permissions);

export default calculateCopyModelPostPayload;
